import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "uppercase text-primary font-bold text-xs lg:text-sm block mb-2" }

interface IPropsCardText {
    title: string
    bold?: boolean
}


export default /*#__PURE__*/_defineComponent({
  props: {
    title: { type: String, required: true, default: '' },
    bold: { type: Boolean, required: false, default: false }
  },
  setup(__props: any) {

const props = __props as { title: string, bold: boolean }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["mb-6 text-dark-gray", { 'font-bold': props.bold }])
  }, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(props.title), 1),
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})